export const nil = (value: any): value is null | undefined => {
    return value === null || value === undefined;
};

export const notNil = <T>(value: T | null | undefined): value is T => {
    return value !== null && value !== undefined;
};
